import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/styles';
import {Grid} from '@material-ui/core';

import {
    List,
    HistoryGraph
} from './components';
import {SingleCalendar, Platform} from '../ECDI/components';
import { getPlatformList, getBestRankList, getBestRankHistory } from '../../apis/api';

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(2)
    }
}));

const Error = () => (<div>Error</div>);

const Best = () => {
    const classes = useStyles();

    const [platformList, setPlatformList] = useState([]);
    const [platform, setPlatform] = useState({});
    const [bestList, setBestList] = useState([]);
    const [historyList, setHistoryList] = useState([]);
    const [options, setOptions] = useState({});

    const getYesterday = () => {
        const standard_date = new Date();
        standard_date.setDate(standard_date.getDate() - 1);

        return standard_date;
    };

    const handleChangePlatform = (platform) => {
        setPlatform(platform);
    }

    const handleSubmit = ({targetDate}) => {
        const {code: platformCode} = platform;

        if (platformCode && targetDate) {
            setOptions({platformCode, targetDate});

            getBestRankList(platformCode, targetDate)
                .then((res) => {
                    if (res.statusCode === 0) return errorHandler();

                    setBestList(res);
                }).catch(() => {
                    return errorHandler();
                });
        }
    };

    const handleProductClick = ({dealCode, productNo}) => {
        const {platformCode, targetDate} = options;

        getBestRankHistory(platformCode, targetDate, dealCode, productNo)
            .then((res) => {
                if (res.statusCode === 0) return errorHandler();

                setHistoryList(res);
            }).catch(() => {
                return errorHandler();
            });
    }

    const errorHandler = () => <Error />;

    useEffect(() => {
        getPlatformList()
            .then((res) => {
                if (res.statusCode === 0) return errorHandler();

                setPlatformList(res);
            }).catch(() => {
                return errorHandler();
            });
    }, []);

    return (
        <div className={classes.root}>
            <Grid
                container
                spacing={2}
            >
                <Grid
                    item
                    lg={6}
                    md={6}
                    xl={6}
                    xs={12}
                >
                    <Platform
                        platformList={platformList}
                        onChange={handleChangePlatform}
                    />
                </Grid>
                <Grid
                    item
                    lg={6}
                    md={6}
                    xl={6}
                    xs={12}
                >
                    <SingleCalendar
                        date_option={{
                            format: 'yyyy/MM/dd',
                            label: 'target date',
                            openTo: 'date',
                            views: ['year', 'month', 'date'],
                            date: getYesterday()
                        }}
                        term="daily"
                        onSubmit={handleSubmit}
                    />
                </Grid>
                <Grid
                    item
                    lg={12}
                    md={12}
                    xl={12}
                    xs={12}
                >
                    <List data={bestList} onClick={handleProductClick} />
                </Grid>
                <Grid
                    item
                    lg={12}
                    md={12}
                    xs={12}
                >
                    <HistoryGraph data={historyList} />
                </Grid>

            </Grid>
        </div>
    );
};

Best.propTypes = {};

export default Best;
